import Layout from '@/components/layout/layout'

const myPersonalRouter = [{
        path: '/my-personal',
        component: Layout,
        redirect: '/my-personal/my_evaluation',
        children: [{
                path: 'evaluation_record',
                component: function (resolve) {
                    require(['VIEWS/my_personal/evaluation_record/index'], resolve)
                },
                name: 'evaluationRecord',
                meta: {
                    title: '测评记录'
                },
            },
            {
                path: 'setting',
                component: function (resolve) {
                    require(['VIEWS/my_personal/setting/index'], resolve)
                },
                name: 'setting',
                meta: {
                    title: '账号设置'
                },
            },
            {
                path: 'vip',
                component: function (resolve) {
                    require(['VIEWS/my_personal/vip/index'], resolve)
                },
                name: 'vip',
                meta: {
                    title: 'vip卡激活'
                },
            },
            {
                path: 'active',
                component: function (resolve) {
                    require(['VIEWS/my_personal/active/index'], resolve)
                },
                name: 'active',
                meta: {
                    title: 'vip卡激活'
                },
            }
        ]
    },
    {
        path: '/redotest',
        component: function (resolve) {
            require(['VIEWS/my_personal/wrong_topic/redotest'], resolve)
        },
        name: 'redotest',
        meta: {
            title: '重做试题'
        },
    },
    {
        path: '/self_assessment',
        component: function (resolve) {
            require(['VIEWS/my_personal/my_evaluation/self_assessment'], resolve)
        },
        name: 'self_assessment',
        meta: {
            title: '自评'
        },
    },
    {
        path: '/evaluation_detail',
        component: function (resolve) {
            require(['VIEWS/my_personal/my_evaluation/evaluation_detail'], resolve)
        },
        name: 'evaluation_detail',
        meta: {
            title: '测评详情'
        },
    },
    {
        path: '/continue_evaluation',
        component: function (resolve) {
            require(['VIEWS/my_personal/my_evaluation/continue_evaluation'], resolve)
        },
        name: 'continue_evaluation',
        meta: {
            title: '继续测评'
        },
    },
    {
        path: '/continue_evaluation_zj',
        component: function (resolve) {
            require(['VIEWS/my_personal/my_evaluation/continue_evaluation_zj'], resolve)
        },
        name: 'continue_evaluation_zj',
        meta: {
            title: '继续测评'
        }
    },
    {
        path: '/paper_hav_do',
        component: function (resolve) {
            require(['VIEWS/my_personal/my_evaluation/paper_hav_do'], resolve)
        },
        name: 'paper_hav_do',
        meta: {
            title: '重做'
        },
    },
    {
        path: '/evaluated_detail',
        component: function (resolve) {
            require(['VIEWS/my_personal/my_evaluation/evaluated_detail'], resolve)
        },
        name: 'evaluated_detail',
        meta: {
            title: '已完成详情'
        },
    },
    {
        path: '/evaluation_detail_cs',
        component: function (resolve) {
            require(['VIEWS/my_personal/my_evaluation/evaluation_detail_cs'], resolve)
        },
        name: 'evaluation_detail_cs',
        meta: {
            title: '详情'
        },
    },
    {
        path: '/explain',
        component: function (resolve) {
            require(['VIEWS/my_personal/wrong_topic/explain'], resolve)
        },
        name: 'explain',
        meta: {
            title: '精讲'
        },
    },
    {
        path: '/reterieve_password',
        component: function (resolve) {
            require(['VIEWS/my_personal/setting/reterieve_password'], resolve)
        },
        name: 'reterieve_password',
        meta: {
            title: '找回密码'
        },
    },
    {
        path: '/web_reterieve_password',
        component: function (resolve) {
            require(['VIEWS/web/setting/reterieve_password'], resolve)
        },
        name: 'web_reterieve_password',
        meta: {
            title: '找回密码'
        },
    }
]
export default myPersonalRouter